var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M22.3136 28.3138L11 17L22.3137 5.68624","stroke":"black","strokeWidth":"2","strokeLinecap":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"32.4211","height":"32.4211","fill":"white"})))]);
}

ChevronLeft.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
